import React, { useContext, useEffect, useMemo, useRef } from 'react';
import { Checkbox } from '../../../atoms/checkbox';
import { FormField, InputValue } from '../donate-form-utils';
import { DonateFormContext } from '../DonateFormContext';
import DonateFormInput from './DonateFormInput';
import GivingFrequencyChoice from './GivingFrequencyChoice';

interface DonateFormFieldsProps {
    fields: { [key in string]: FormField };
};

const donateFormTiles = Array.from(document.getElementsByTagName('formcomplete'));

// handle these explicitly
const IGNORED_FIELDS = ['message', 'amount']; //, 'First Name', 'Last Name', 'Email'];

const DonateFormFields = ({ fields }: DonateFormFieldsProps) => {
    const {formState, updateFormState} = useContext(DonateFormContext);
    const otherFields = useMemo(() => Object.values(fields).filter((field) => !IGNORED_FIELDS.includes(field.fieldInputProps.name!)), []);
    const amountRef = useRef<HTMLInputElement>(null);

    const onInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        updateFormState(name, value);
    };

    useEffect(() => {
        // hooking onto the tile amounts across an appeal page and linking them to
        // our amount input
        donateFormTiles.forEach((tile) => {
            tile.addEventListener('click', () => {
                updateFormState('amount', tile.getAttribute('data-amount') ?? '0');
                amountRef.current?.scrollIntoView({ behavior: 'smooth' });
            });
        });
    }, []);

    const { amount, message } = fields;

    return (
        <div className="layout-grouping-children layout-grouping-children--medium">
            <GivingFrequencyChoice />
            <div ref={amountRef}>
                <DonateFormInput
                    field={amount}
                    handleInputChange={onInputChange}
                    value={formState[amount.fieldInputProps.name!] ?? ''}
                />
            </div>
            {otherFields.map((field) => (
                <DonateFormInput
                    key={field.name}
                    field={field}
                    handleInputChange={onInputChange}
                    value={formState[field.fieldInputProps.name!] ?? ''}
                />
            ))}
            {message && (
                <div>
                    <DonateFormInput
                        field={message}
                        handleInputChange={onInputChange}
                        value={formState[message.fieldInputProps.name!] ?? ''}
                    />
                    <Checkbox
                        id="anonymously-donate"
                        labelSlot="Donate anonymously?"
                        onChange={(value) => updateFormState('comment_anonymous', `${value}`)}
                    />
                </div>
            )}
        </div>
    )
}

export default DonateFormFields;
